import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import styled from 'styled-components'

import { COLORS } from '@/constants'

const LinkElement = styled(RouterLink)`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 1.25px;
  text-transform: uppercase;
  color: ${({ color }) => color};
  text-decoration: none;
  &:hover {
    color: ${({ $colorHover }) => $colorHover};
  }
`


const Link = ({
 to,
 children,
 color = COLORS.blackDisabled,
 colorHover = COLORS.primary600,
}) => (
    <LinkElement to={to} color={color} $colorHover={colorHover}>
        {children}
    </LinkElement>
)

export { Link }
